// extracted by mini-css-extract-plugin
export default {"Wrapper":"Wrapper_Wrapper__Ob0kh","Aside":"Wrapper_Aside__77Fh7"};